import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { WHATSAPP } from "../data";
import { WaIcon } from "../components/Cta";

export default function StickyWhatsApp() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <>
          {/* Mobile: full-width bar */}
          <motion.a
            href={WHATSAPP}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="sticky-whatsapp-mobile"
            initial={{ y: 80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 80, opacity: 0 }}
            transition={{ duration: 0.35 }}
            className="fixed bottom-0 left-0 right-0 z-[9500] flex items-center justify-center gap-3 bg-[#25D366] py-4 font-display text-lg font-bold uppercase tracking-wide text-black sm:hidden"
          >
            <WaIcon className="h-6 w-6" />
            Agende sua Avaliação
          </motion.a>

          {/* Desktop: floating pill */}
          <motion.a
            href={WHATSAPP}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="sticky-whatsapp-desktop"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            whileHover={{ scale: 1.06 }}
            className="wa-pulse fixed bottom-7 right-7 z-[9500] hidden h-16 w-16 items-center justify-center rounded-full bg-[#25D366] text-black shadow-lg sm:flex"
            aria-label="Agende pelo WhatsApp"
          >
            <WaIcon className="h-8 w-8" />
          </motion.a>
        </>
      )}
    </AnimatePresence>
  );
}
